export default __webpack_public_path__ + "static/media/grocerylist.476c8fdd.png";